import { render, staticRenderFns } from "./BridgeWriteBody.vue?vue&type=template&id=c65867d8&scoped=true"
import script from "./BridgeWriteBody.vue?vue&type=script&lang=js"
export * from "./BridgeWriteBody.vue?vue&type=script&lang=js"
import style0 from "./BridgeWriteBody.vue?vue&type=style&index=0&id=c65867d8&prod&scoped=true&lang=scss"
import style1 from "./BridgeWriteBody.vue?vue&type=style&index=1&id=c65867d8&prod&scoped=true&lang=scss"
import style2 from "./BridgeWriteBody.vue?vue&type=style&index=2&id=c65867d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65867d8",
  null
  
)

export default component.exports